/**
 * Recuperação de falhas ao baixar código sob demanda (chunks/imports dinâmicos):
 * - produção: após um deploy, o navegador pede um arquivo com hash antigo;
 * - desenvolvimento: o Vite reotimiza dependências e invalida o import em andamento.
 *
 * Nos dois casos, repetir o mesmo `import()` falha de novo (o navegador guarda
 * o erro); só recarregar a página resolve. Recarrega UMA vez por janela de tempo
 * para nunca entrar em loop se o problema persistir.
 */

const FLAG = "crialume:chunk-reload";
/** Depois disso sem novas falhas, uma próxima falha pode recarregar de novo. */
const STABLE_AFTER_MS = 10_000;

const CHUNK_ERROR =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|loading (css )?chunk|outdated optimize dep/i;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_ERROR.test(error.message);
}

/** Recarrega se ainda não recarregou nesta janela. `false` = já tentou (mostre a ação manual). */
export function reloadOnce(): boolean {
  try {
    if (sessionStorage.getItem(FLAG)) return false;
    sessionStorage.setItem(FLAG, String(Date.now()));
  } catch {
    // Sem sessionStorage: não arrisca loop.
    return false;
  }
  window.location.reload();
  return true;
}

/** Registra o tratamento global (chame uma vez no boot). */
export function installChunkReload(): void {
  // Chunk antigo após deploy (preload do Vite).
  window.addEventListener("vite:preloadError", (event) => {
    if (reloadOnce()) event.preventDefault();
  });
  // Os módulos carregam DEPOIS do `load`: só libera nova recarga com o app estável.
  window.addEventListener("load", () => {
    setTimeout(() => {
      try {
        sessionStorage.removeItem(FLAG);
      } catch {
        // ignora
      }
    }, STABLE_AFTER_MS);
  });
}
